export type SettleTerms = (accepted: boolean) => void;

export const TERMS_CONFIRM_EVENT = "contact:terms-confirm";

export const confirmTermsAcceptance = () =>
  new Promise<boolean>((resolve) => {
    const event = new CustomEvent<SettleTerms>(TERMS_CONFIRM_EVENT, {
      cancelable: true,
      detail: resolve,
    });
    if (window.dispatchEvent(event)) resolve(true);
  });
